module.exports = __webpack_public_path__ + "static/media/037.4ee31904.png";